import ChevronRight from './chevron-right';

export * from './chevron-right';
export default ChevronRight;
